import type React from "react";
import { Footer } from "@/components/layout/footer";
import { Header } from "@/components/layout/header";
import { AppSidebar } from "@/components/layout/app-sidebar";

export function MainLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="aero:flex aero:h-screen aero:w-full aero:flex-col aero:overflow-hidden aero:overscroll-none">
      <Header />
      <div className="aero:flex-1 aero:overflow-auto aero:overscroll-contain">
        <div className="aero:flex aero:flex-col aero:min-h-full">
          <div className="aero:flex aero:flex-1">
            <div className="aero:hidden aero:md:flex aero:border-r aero:border-neutral-200 aero:bg-white">
              <div className="aero:sticky aero:top-0 aero:h-fit aero:max-h-[calc(100vh-5rem)] aero:overflow-y-auto aero:overflow-x-hidden aero:overscroll-contain">
                <AppSidebar />
              </div>
            </div>
            <main className="aero:flex-1 aero:min-w-0 aero:px-5 aero:bg-neutral-100 aero:py-11 aero:pb-[96px] aero:md:px-10 aero:md:pb-6">
              {children}
            </main>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}
